// src/Dashboard/pages/teacher/PrepaPhysique/components/PrepaPhysiqueKpiCards.jsx

import React from "react";
import {
  FaCheckCircle,
  FaDumbbell,
  FaHourglassHalf,
  FaTasks,
  FaUserFriends,
} from "react-icons/fa";

const CARDS = [
  {
    key: "exercises",
    label: "Exercices",
    icon: FaDumbbell,
    tone:
      "bg-blue-50 text-blue-700 ring-blue-200 dark:bg-blue-900/20 dark:text-blue-200 dark:ring-blue-800/60",
  },
  {
    key: "assignments",
    label: "Affectations",
    icon: FaTasks,
    tone:
      "bg-indigo-50 text-indigo-700 ring-indigo-200 dark:bg-indigo-900/20 dark:text-indigo-200 dark:ring-indigo-800/60",
  },
  {
    key: "done",
    label: "Réalisés",
    icon: FaCheckCircle,
    tone:
      "bg-emerald-50 text-emerald-700 ring-emerald-200 dark:bg-emerald-900/20 dark:text-emerald-200 dark:ring-emerald-800/60",
  },
  {
    key: "notDone",
    label: "À faire",
    icon: FaHourglassHalf,
    tone:
      "bg-amber-50 text-amber-700 ring-amber-200 dark:bg-amber-900/20 dark:text-amber-200 dark:ring-amber-800/60",
  },
  {
    key: "distinctAdherents",
    label: "Adhérents suivis",
    icon: FaUserFriends,
    tone:
      "bg-slate-50 text-slate-700 ring-slate-200 dark:bg-slate-800/60 dark:text-slate-200 dark:ring-slate-700",
  },
];

export default function PrepaPhysiqueKpiCards({ stats, loading }) {
  return (
    <div className="grid grid-cols-2 gap-3 lg:grid-cols-5">
      {CARDS.map((card) => {
        const Icon = card.icon;

        return (
          <div
            key={card.key}
            className={`rounded-2xl px-4 py-3 ring-1 ${card.tone}`}
          >
            <div className="flex items-center justify-between gap-3">
              <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-white/70 dark:bg-white/10">
                <Icon />
              </span>

              <span className="text-2xl font-bold">
                {loading ? "…" : stats?.[card.key] ?? 0}
              </span>
            </div>

            <p className="mt-2 text-xs font-bold uppercase tracking-wide opacity-80">
              {card.label}
            </p>
          </div>
        );
      })}
    </div>
  );
}